import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLighting = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 24,
	viewBox: "0 0 25 24",
	width: 25,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "#000",
		strokeOpacity: .87,
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "m17.5 16.1504c2.0711 0 3.75-1.679 3.75-3.75h-7.5c0 2.071 1.6789 3.75 3.75 3.75z",
				fill: "#fff",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m17.4992 6.98242c-2.9929 0-5.4191 2.42622-5.4191 5.41918h10.8383c0-2.99296-2.4262-5.41918-5.4192-5.41918z",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m7.5 22v-15c0-2.76143 2.23857-5 5-5 2.7614 0 5 2.23857 5 5",
				strokeLinecap: "square",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgLighting;
